import React from "react";
import styled from "styled-components";
// import pic from "./ASSESTS/COMPONENTS/herobg.png";
import pic from "./ASSESTS/Food/hero1.png";
import { BsSearch } from "react-icons/bs";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import {Fade} from "react-awesome-reveal"
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';


const Hero = () => {

  
  return (
    <div>
      
       <Container>
   
        <First>
          <TextHold>
             <Fade
              duration={2000}
            >
               <Title>Low cost. High quality.
We are always here to serve you.</Title>
            </Fade>
           
            <Fade direction="down">
            
            <Sub>Exclusive collection for everyone</Sub>
            </Fade>
            <Hold>
              <Button to="/product">
                Explore now
                <Icn>
                  {" "}
                  <BsSearch />
                </Icn>
              </Button>
            </Hold>
          </TextHold>
        </First>
       
      </Container>
      {/* <Holder>
      <Swiper
    {...{ spaceBetween: 50 } as any}
    slidesPerView={3}
    onSlideChange={() => console.log('slide change')}
    onSwiper={(swiper) => console.log(swiper)}
    >
      <SwiperSlide>Slide 1</SwiperSlide>
      <SwiperSlide>Slide 2</SwiperSlide>
      <SwiperSlide>Slide 3</SwiperSlide>
      <SwiperSlide>Slide 4</SwiperSlide>
      ...
    </Swiper>
      </Holder>
  */}
    
    </div>
  );
};

export default Hero;

const Holder = styled.div`
  
  width: 100%;
  height: 60vh;
  background-color: purple;
`

const Hold = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 11111111;
padding-bottom: 50px;
 
`;

const Icn = styled.div`
  margin-left: 8px;
  font-size: 15px;
`;

const Button = styled(Link)`
  width: 150px;
  height: 50px;
  background-color: black;
  color: white;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1111111;
  text-decoration: none;
  font-size: 15px;
`;

const Sub = styled.div`
  font-size: 50px;
  font-weight: bold;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items:center;
  text-align: center;
  width: 100%;
  @media screen and (max-width: 768px) {
    font-size: 35px;
    
  
  }
  
`;

const Title = styled.div`
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items:center;
  text-align: center;
  width: 100%;
  margin-bottom: 30px;
  z-index: 1111;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    
  
  }
`;

const TextHold = styled.div`
  display: flex;
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items:center;
  text-align: center;
  width: 100%;
  z-index: 11;
`;

const Second = styled.div`
  width: 70%;
  margin-top: 70px;
  @media screen and (max-width: 768px) {
    width: 300px;
    height: 300px;
    
  
  }
  img {
    height: 500px;
    object-fit: cover;
    @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    
    
  
  }
  }
`;

const First = styled.div`
  /* width: 40%; */
  margin-left: 80px;
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  @media screen and (max-width: 768px) {
    width: 300px;
    
    margin-left: 20px;
  }
`;

const Container = styled.div`
  width: 100%;
  /* height: 500px; */
  /* height: calc(100vh); */
  /* background-color: #e3ffe6; */
  // background-color: #80008087;
  /* background-color: #D2CDEB; */
  display: flex;
  align-items: center;
  justify-content: center;
background-image: url(${pic});
background-color: white;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    backdrop-filter: blur(5px);
position: relative;

margin-top: 70px;
    ::before{
        content: "";
        width: 100%;
        height: 100%;
        background-color: #0000001b;
        position: absolute;
        backdrop-filter: blur(5px);
       
    }
  @media screen and (max-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 50px;
    /* background-color: #e3ffe6; */
    
  
  }
`;
